/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from '../../mutation-types';

const state = {
  kiosk: {
  },
  error: null,
  availableLanguages: [],
  defaultLanguages: [],
  kioskLanguages: [],
};

const getters = {
  kiosk: state => state.kiosk,
  error: state => state.error,
  availableLanguages: state => state.availableLanguages,
  defaultLanguages: state => state.defaultLanguages,
  kioskLanguages: state => state.kioskLanguages,
};

const actions = {
  fetch({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/kiosks/${payload.id}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
  add({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    let request;
    if (payload.kiosk.id) {
      request = Vue.http.put(`${process.env.BACKEND_API_URL}api/${path}/kiosks/${payload.kiosk.id}`, payload.kiosk);
    } else {
      request = Vue.http.post(`${process.env.BACKEND_API_URL}api/${path}/kiosks`, payload.kiosk);
    }
    return request
      .then((response) => {
        commit(mTypes.DATA_STORED, response);
      })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  fetchLanguages({ commit }) {
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/kiosk-languages`)
      .then((response) => {
        commit(mTypes.LANGUAGES_FETCHED, response.data);
      });
  },
  reboot(context, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.post(`${process.env.BACKEND_API_URL}api/${path}/kiosks/${payload.id}/reboot`)
      .then(response => response.body);
  },
  rebootStatus(context, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/kiosks/${payload.id}/reboot-status`)
      .then(response => response.body);
  },
  delete({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.delete(`${process.env.BACKEND_API_URL}api/${path}/kiosks/${payload.id}`)
      .then(() => {
      })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response.body.error);
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, kiosk) {
    state.kiosk = kiosk.data;
    state.error = null;
    if (kiosk.data.available_languages) {
      state.availableLanguages = kiosk.data.available_languages;
    }
    if (kiosk.data.languages) {
      state.kioskLanguages = kiosk.data.languages;
    }
  },
  [mTypes.LANGUAGES_FETCHED](state, languages) {
    state.availableLanguages = languages.available_languages || [];
    state.defaultLanguages = languages.languages || [];
  },
  [mTypes.CLEAR_STATE](state) {
    state.kiosk = {};
  },
  [mTypes.DATA_STORED](state, kiosk) {
    state.kiosk = kiosk.data;
  },
  [mTypes.DATA_ERROR](state, error) {
    state.error = error === null ? error : error.data.message;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/kiosks/kiosk.js